import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDisplayUrl } from '../../../../utils/storeUrl';
import {
    Card,
    Head,
    Avatar,
    NameBlock,
    Name,
    Status,
    UrlRow,
    Url,
    CopyButton,
    Divider,
    Product,
    ProductThumb,
    ProductText,
    ProductName,
    ProductPrice,
    Skeleton,
} from './StorePreviewCard.styles';

/**
 * Store card for the last step: initial, name, optional "Activa" (only when the backend says so),
 * public URL with "Copiar", and the first product if there is one.
 */
const StorePreviewCard = ({
    loading = false,
    name,
    storeUrl,
    isActive = false,
    product,
    copied = false,
    onCopy,
}) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <Card aria-busy="true" aria-label={t('SignUpV2.lista.loadingStore')}>
                <Head>
                    <Skeleton w="48px" h="48px" round />
                    <NameBlock style={{ flex: 1, gap: 8 }}>
                        <Skeleton w="60%" h="16px" />
                        <Skeleton w="30%" h="12px" />
                    </NameBlock>
                </Head>
                <UrlRow>
                    <Skeleton w="70%" h="14px" />
                </UrlRow>
            </Card>
        );
    }

    const initial = (name || '').trim().charAt(0) || 'E';

    return (
        <Card>
            <Head>
                <Avatar aria-hidden="true">{initial}</Avatar>
                <NameBlock>
                    <Name title={name}>{name}</Name>
                    {isActive && <Status>{t('SignUpV2.lista.active')}</Status>}
                </NameBlock>
            </Head>
            {storeUrl && (
                <UrlRow>
                    <i className="ri-link" aria-hidden="true" />
                    <Url title={storeUrl}>{getDisplayUrl(storeUrl)}</Url>
                    <CopyButton type="button" onClick={onCopy}>
                        <i
                            className={copied ? 'ri-check-line' : 'ri-file-copy-line'}
                            aria-hidden="true"
                        />
                        <span>
                            {copied ? t('SignUpV2.lista.copied') : t('SignUpV2.lista.copy')}
                        </span>
                    </CopyButton>
                </UrlRow>
            )}
            {product && (
                <>
                    <Divider />
                    <Product>
                        <ProductThumb aria-hidden="true">
                            {product.imageUrl ? (
                                <img src={product.imageUrl} alt="" />
                            ) : (
                                <i className="ri-shopping-bag-3-line" />
                            )}
                        </ProductThumb>
                        <ProductText>
                            <ProductName title={product.name}>{product.name}</ProductName>
                            <ProductPrice>{product.priceLabel}</ProductPrice>
                        </ProductText>
                    </Product>
                </>
            )}
        </Card>
    );
};

export default StorePreviewCard;
